import React from 'react';

type SectionHeaderProps = {
    title: string;
    subtitle?: string;
    className?: string;
    id?: string;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({
    title,
    subtitle,
    className = '',
    id,
}) => (
    <header className={`section-header ${className}`.trim()}>
        <h2 id={id} className="section-header__title">{title}</h2>
        {subtitle && <p className="section-header__subtitle">{subtitle}</p>}
    </header>
);

export default SectionHeader;
